import { DesktopCapturerSource } from 'electron'
import { isElectron } from './electron'

export enum ScreenSourceType {
  SOURCE_SCREEN = 'screen',
  SOURCE_WINDOW = 'window'
}

export async function getScreenSources(
  sourceType: ScreenSourceType | null = null
) {
  if (!isElectron()) {
    console.log('Not support getting screen sources in non-electron mode')
    return
  }
  if (!window.capturer) return

  try {
    // invoke main process to read from file system
    return window.capturer.getSources({
      types: sourceType
        ? [sourceType]
        : [ScreenSourceType.SOURCE_SCREEN, ScreenSourceType.SOURCE_WINDOW],
      thumbnailSize: {
        width: 1920,
        height: 1080
      }
    })
  } catch (err) {
    throw err
  }
}
